export const MIN_AUDIO_DURATION_MS = 1000

export type VoiceInsertMode = 'append' | 'replace'

export function isAudioLongEnough(durationMs: number): boolean {
  return durationMs >= MIN_AUDIO_DURATION_MS
}

export function mergeTranscribedText(currentValue: string, transcribedText: string, mode: VoiceInsertMode): string {
  const nextText = transcribedText.trim()
  if (!nextText) return currentValue
  if (mode === 'replace') return nextText
  const currentText = currentValue.trimEnd()
  return currentText ? `${currentText}\n${nextText}` : nextText
}
